// extracted by mini-css-extract-plugin
module.exports = {"checkBoxSpinner":"CheckBoxSpinner-checkBoxSpinner-3ieCZ","spin":"CheckBoxSpinner-spin-2u7QS"};